import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter, SearchService } from '@docpath/linces-angular-components';
import { DpHeaderOption, HeaderAction, SearchBasicInfo, SearchRowInfo } from '@docpath/webcomponents';

import { AlertRule } from '../../../configuration/alert-rules/models/alert-rule';
import { Alert } from '../../models/alert';
import { MonitoringService } from '../../services/monitoring.service';
import { MonitoringTableService } from '../table/monitoring-table.service';
import { MonitoringHeaderService } from './monitoring-header.service';



@Component({
  selector: 'app-monitoring-header',
  templateUrl: './monitoring-header.component.html'
})
export class MonitoringHeaderComponent implements OnInit {
  @Input() alerts: Alert[] = [];
  @Output() filtersChanged = new EventEmitter<Filter[]>();
  @Output() columnVisibilityChanged = new EventEmitter<DpHeaderOption>();

  rightActions: HeaderAction[] = [];
  leftActions: HeaderAction[] = [];

  alertRules: AlertRule[] = [];

  showSearch = false;

  private filters: Filter[] = [];

  @Input() dgeId!: number;

  searchPossibleFilters: SearchRowInfo[] = [];
  searchSelectedFilters: SearchRowInfo[] = [];
  searchAvailableOptions: SearchRowInfo[] = [];

  constructor(
    private readonly monitoringHeaderService: MonitoringHeaderService,
    private readonly monitoringTableService: MonitoringTableService,
    private readonly monitoringService: MonitoringService,
    private readonly searchService: SearchService
  ) {
    this.leftActions = this.monitoringHeaderService.getLeftActions();
    this.searchAvailableOptions = this.monitoringHeaderService.initSearchAvailableOptions();
    this.rightActions = this.monitoringHeaderService.getRightActions();
    const searchAction = this.monitoringHeaderService.getSearchAction(this.rightActions);

    searchAction.action = () => {
      this.showSearch = !this.showSearch;
    };

  }

  ngOnInit(): void {
    this.monitoringService.dgeChanged.subscribe(dgeId => {
      this.dgeId = dgeId;
      this.monitoringHeaderService.updateRightActions(this.dgeId, this.rightActions);
    });
  }

  isSearchVisible(): boolean {
    return this.showSearch;
  }

  clearSearch(): void {
    this.filters = [];
    this.filtersChanged.emit(this.filters);
    this.monitoringTableService.loadAlerts(this.dgeId, this.filters, 1);
    this.leftActions = [];
  }


  sendSearch(currentFilters: Array<SearchBasicInfo>): void {
    this.filters = this.searchService.toFilters(currentFilters);
    this.filtersChanged.emit(this.filters);
    this.monitoringTableService.loadAlerts(this.dgeId, this.filters, 1);
    this.leftActions = [];
  }

  hideSearch(): void {
    this.showSearch = false;
  }

  onChecklistOptionChanged(option: DpHeaderOption): void {
    const selectedFilter = this.searchSelectedFilters.find(filter => filter.key === option.value),
      possibleFilter = this.searchPossibleFilters.find(filter => filter.key === option.value);

    if (selectedFilter) {
      selectedFilter.visible = option.checked;
    }

    if (possibleFilter) {
      possibleFilter.visible = option.checked;
    }

    this.columnVisibilityChanged.emit(option);
  }


  onSelectedFiltersInitialized(filters: SearchRowInfo[]): void {
    this.searchSelectedFilters = filters;
  }

  onPossibleFiltersInitialized(filters: SearchRowInfo[]): void {
    this.searchPossibleFilters = filters;
  }


}
